import React from "react";
import styled from "styled-components";

import Text from "@ingka/text";

export type StyledHeadingProps = {
	as: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
	children?: React.ReactNode;
};

export const StyledHeading = styled(Text)`
	margin: 0 0 0.25rem 0;
`;

const LayoutHeading: React.FC<{
	label?: string | React.ReactElement;
	headingLevel?: number;
}> = ({ headingLevel = 2, label }) => {
	// Only proceed if 'label' is a non-empty string; otherwise, return null
	if (typeof label !== "string" || !label) return null;

	const level = Math.min(headingLevel, 6);
	const headingTag = `h${level}` as StyledHeadingProps["as"];
	const headingSize = level < 3 ? "Heading.M" : "Heading.S";

	return (
		<StyledHeading tagName={headingTag} textStyle={headingSize}>
			{label}
		</StyledHeading>
	);
};

export default LayoutHeading;
